<a
  class="product-card cg__primary-card {{ vertical ? 'vertical' : 'horizontal' }} {{ size }} {{
    responsive ? 'responsive' : ''
  }} {{ productCard?.decoratedName ? ' hasSubcategory' : '' }}"
  [routerLink]="['/producto/' + productCard.link]"
  queryParamsHandling="merge"
  [queryParams]="{ liqui: null }">
  @if (productCard?.decoratedName) {
    <div
      class="product-card__subcategory txt_quantity cg__fw-600 my-1"
      (click)="onActionButtonClick($event)">
      <span>
        {{
          productCard?.subcategory?.nombre ? productCard?.subcategory?.nombre : 'Sin subcategoría'
        }}
      </span>
    </div>
  }
  <div class="product-card__image {{ size }}">
    <cgw-item-image
      [name]="productCard?.imageName"
      [alt]="productCard?.name"
      [size]="size"
      [absoutePath]="!productCard?.imageName">
    </cgw-item-image>
    @if (productCard?.liquidation) {
      <cgw-liquidation-logo
        class="product-card__promoLogo"
        [liquidations]="productCard.liquidation"
        [size]="vertical ? 'medium' : 'small'"
        [idProduct]="productCard.id"></cgw-liquidation-logo>
    } @else if (productCard.id | isProductHighlighted) {
      <div class="product-card__promoLogo">
        <img
          src="{{ assetsImage }}highlighted-standard.png"
          alt="{{ highlightedProductsService.altHighlighted | async }}" />
      </div>
    }
  </div>
  @if (productCard?.decoratedName) {
    <h3
      class="product-card__title cg__fw-600 {{
        vertical && (actionButtons | async) ? 'mb-5' : ''
      }}">
      {{ productCard?.decoratedName }}
    </h3>
  } @else {
    <h3
      class="product-card__title cg__fw-400 {{
        vertical && (actionButtons | async) ? 'mb-5' : ''
      }}">
      {{ productCard?.name }}
    </h3>
  }

  @if (actionButtons | async) {
    <div class="product-card__cart">
      <div class="product-card__cart__price">
        <span class="product-card__cart__price--current txt_button cg__fw-600"
          ><span class="txt_button">$</span>
          <span class="txt_price">{{
            productCard?.price | currency: 'ARS' : '' : '1.0-0' : 'es-AR'
          }}</span>
        </span>
        @if (productCard?.previousPrice > productCard?.price) {
          <span class="product-card__cart__price--previous txt_caption">
            <span class="txt_legals">$</span>
            <span class="product-card__cart__price--previous__price">{{
              productCard?.previousPrice | currency: 'ARS' : '' : '1.0-0' : 'es-AR'
            }}</span>
          </span>
        }
      </div>
      @if (cartButton) {
        <div
          class="product-card__cart__button"
          (click)="onActionButtonClick($event)">
          <cgw-action-button [data]="addCardButton"></cgw-action-button>

          @if (cartCount()) {
            <span class="cart__count">
              {{ cartCount() }}
            </span>
          }
        </div>
      }
    </div>
    @if (productCard?.discount) {
      <div class="product-card__chip product-card__chip--discount d-flex py-1 px-2">
        <span class="material-symbols-outlined product-card__chip--discount__icon mr-1">
          sell
        </span>
        <div class="d-flex flex-column">
          <span class="txt_caption">Descuento</span>
          <span class="txt_button cg__fw-500">
            @if (productCard?.discount > 5000) {
              <span class="txt_legals cg__fw-600">$</span>
            }
            {{
              productCard?.discount > 5000 ?
                (productCard?.discount | currency: 'ARS' : '' : '1.0-0' : 'es-AR')
              : getLiquidationName(productCard?.liquidation)
            }}
          </span>
        </div>
      </div>
    }
  }
</a>
